import React from "react";
import "./style.css";
export default function Button(props) {
  return (
    <button
      id={props.id}
      type={props.type}
      className="button"
      onClick={props.event}
      disabled={props.disabled}
      tabIndex={props.tabIndex}
      title={props.title ?? props.placeholder}
      style={{
        marginBottom: props.marginBottom,
        marginRight: props.marginright,
        marginLeft: props.marginleft,
        marginTop: props.margintop,
        minWidth: props.minWidth,
        width: props.width,
        height: props.height,
        border: props.border,
        background: props.background,
        backgroundColor: props.backgroundcolor,
        color: props.colo,
        whiteSpace: props.whitespace,
        borderRadius: props.borderRadius,
        padding: props.padding,
        fontSize: props.fontsize,
        opacity: props.disabled ? 0.3 : props.opacity,
      }}
    >
      {props.placeholder}
    </button>
  );
}

/* <Button
event={() => {

}}
placeholder="Sair"
width={}
height={}
margintop={}
/> */
